export default {
  "content": "<path d=\"M24 21.3V2.7C24 1.2 22.8 0 21.3 0H2.7A2.7 2.7 0 000 2.7v18.6C0 22.8 1.2 24 2.7 24h18.6c1.5 0 2.7-1.2 2.7-2.7zM7.3 14l3.4 4 4.6-6 6 8H2.7l4.6-6z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "#CDD1D4",
    "viewBox": "0 0 24 24"
  }
};